import { createSelector } from 'reselect';

const campaignSelector = state => state.campaign;

// CAMPAIGN
export const currentDigest = createSelector(campaignSelector, state => state.digest);
export const digests = createSelector(campaignSelector, state => state.digests);
export const getDigests = createSelector(campaignSelector, state => state.digests);
export const currentHotw = createSelector(campaignSelector, state => state.hotw);
export const homesOfTheWeek = createSelector(campaignSelector, state => state.hotws);
export const currentPromoAlert = createSelector(campaignSelector, state => state.promoAlert);
export const promoAlerts = createSelector(campaignSelector, state => state.promoAlerts);
export const topPosts = createSelector(campaignSelector, state => state.topPosts);
export const searchPosts = createSelector(campaignSelector, state => state.searchPosts);
export const recentPosts = createSelector(campaignSelector, state => state.recentPosts);
export const dayOptions = createSelector(campaignSelector, state => state.dayOptions);
export const campaignListings = createSelector(campaignSelector, state => state.listings);
export const hotwQuery = createSelector(campaignSelector, state => state.hotwQuery);
export const promoAlertQuery = createSelector(campaignSelector, state => state.promoAlertQuery);
export const cityRinkQuery = createSelector(campaignSelector, state => state.cityRinkQuery);
export const digestFormats = createSelector(campaignSelector, () => {
  const options = ['Daily Digest', 'Hot Headlines', 'Dining Report'].map(digest => ({
    key: digest,
    text: digest,
    value: digest,
  }));
  return [...options, { key: '', text: 'All', value: '' }];
});
export const promoAlertFormats = createSelector(campaignSelector, () => {
  const options = ['Promo Alert', 'Insider Invite'].map(digest => ({
    key: digest,
    text: digest,
    value: digest,
  }));
  return [...options, { key: '', text: 'All', value: '' }];
});
export const hotwAlertFormats = createSelector(campaignSelector, () => {
  const options = ['Homes of the Week', 'Showcase', 'Gift Guide'].map(digest => ({
    key: digest,
    text: digest,
    value: digest,
  }));
  return [...options, { key: '', text: 'All', value: '' }];
});

// https://github.com/reduxjs/reselect#q-how-do-i-create-a-selector-that-takes-an-argument
export const getDigestById = digestId => {
  return createSelector(getDigests, digests => {
    return digests.find(digest => digest.id === digestId);
  });
};
